class HubspotForm {
    constructor(formElement) {
        if (!formElement) {
            return
        }
        this.formElement = formElement
        this.initTextareaListeners()
    }

    initTextareaListeners() {
        this.formElement.querySelectorAll('.hs-input.hs-fieldtype-textarea').forEach((textarea) => {
            textarea.addEventListener('input', () => this.fixHeightForTextarea(textarea))
        })
    }

    fixHeightForTextarea(textarea) {
        textarea.style.height = 'auto'
        textarea.style.height = textarea.scrollHeight + 'px'
    }
}

function initHubSpotForm() {
    document.addEventListener('afterHubSpotFormLoadedCompletelyEvent', (e) => {
        new HubspotForm(e.detail)
    })
}

if (document.readyState !== 'loading') {
    initHubSpotForm()
} else {
    document.addEventListener('DOMContentLoaded', initHubSpotForm)
}
